$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  let filterByFromQuery = $("body").attr("filter_by") || null;
  let startDateFromQuery =
    $("body").attr("start_date")?.replace("T", " ") || null;
  let endDateFromQuery = $("body").attr("end_date")?.replace("T", " ") || null;
  let customPeriodFromQuery = $("body").attr("custom_period") || null;
  let prevSelectedPeriodFromQuery =
    $("body").attr("prev_selected_period") || null;

  if (p === "statistic_product_group") {
    setDateAndPeriod(
      startDateFromQuery,
      endDateFromQuery,
      filterByFromQuery,
      customPeriodFromQuery,
      prevSelectedPeriodFromQuery
    );

    let customerId = 0;
    let orderBy = "name";
    let orderByDirection = "desc";
    let isSorting = false;

    if (deviceWidth < 768) {
      isMobile = true;
    } else if (deviceWidth >= 768 && deviceWidth < 992) {
      isTablet = true;
    } else {
      isDesktop = true;
    }

    if (filterBy) {
      $("#compare").prop("disabled", false);

      let periodTitleOfFilterBy = "";
      prevSelectedPeriod = prevSelectedPeriodQuery
        ? prevSelectedPeriodQuery
        : prevSelectedPeriod;
      if (filterBy === "week") {
        $("#period-week").prop("checked", true);
        period = "week";
        prevSelectedPeriod = "week";
        customPeriod = customPeriodQuery ? customPeriodQuery : "day";
        startDate = startDateQuery
          ? startDateQuery
          : moment().startOf("week").format("YYYY-MM-DD") + " 00:00";
        endDate = endDateQuery
          ? endDateQuery
          : moment().endOf("week").format("YYYY-MM-DD") + " 23:59";
        periodTitleOfFilterBy = "Uke nr" + " " + moment(startDate).isoWeek();
      } else if (filterBy === "day") {
        $("#period-day").prop("checked", true);
        customPeriod = customPeriodQuery ? customPeriodQuery : "time";
        startDate = startDateQuery
          ? startDateQuery
          : moment().startOf("week").format("YYYY-MM-DD") + " 00:00";
        endDate = endDateQuery
          ? endDateQuery
          : moment().endOf("week").format("YYYY-MM-DD") + " 23:59";
        $(`#custom-period option[value="time"]`).prop("selected", true);

        periodTitleOfFilterBy = dayFormatAbbreviation(
          moment(startDate).format("ddd - DD.MM.YYYY")
        );
      } else if (filterBy === "month") {
        $("#period-month").prop("checked", true);
        period = "month";
        prevSelectedPeriod = "month";
        startDate = startDateQuery
          ? startDateQuery
          : moment().startOf("week").format("YYYY-MM-DD") + " 00:00";
        endDate = endDateQuery
          ? endDateQuery
          : moment().endOf("week").format("YYYY-MM-DD") + " 23:59";
        if (isDesktop) {
          customPeriod = "day";
          $(`#custom-period option[value="time"]`).prop("selected", false);
          $(`#custom-period option[value="day"]`).prop("selected", true);
        } else {
          customPeriod = "week";
          $(`#custom-period option[value="day"]`).prop("selected", false);
          $(`#custom-period option[value="week"]`).prop("selected", true);
          $(`#custom-period option[value="day"]`).prop("disabled", true);
        }
        periodTitleOfFilterBy = moment(startDate).format("MMMM");
      } else if (filterBy === "year") {
        $("#period-year").prop("checked", true);
        period = "year";
        prevSelectedPeriod = "year";
        startDate = startDateQuery
          ? startDateQuery
          : moment().startOf("week").format("YYYY-MM-DD") + " 00:00";
        endDate = endDateQuery
          ? endDateQuery
          : moment().endOf("week").format("YYYY-MM-DD") + " 23:59";
        customPeriod = "month";
        $(`#custom-period option[value="time"]`).prop("selected", false);
        $(`#custom-period option[value="month"]`).prop("selected", true);
        periodTitleOfFilterBy = moment(startDate).format("YYYY");

        $("#compare").prop("disabled", true);
      } else {
        period = "custom";
        customPeriod = customPeriodQuery ? customPeriodQuery : customPeriod;
        prevSelectedPeriod = prevSelectedPeriodQuery
          ? prevSelectedPeriodQuery
          : prevSelectedPeriod;
        startDate = startDateQuery;
        endDate = endDateQuery;
        $("#period-custom").prop("checked", true);
        $(`#custom-period option[value=${customPeriod}]`).prop(
          "selected",
          true
        );
        $("#start-date").val(startDate);
        $("#end-date").val(endDate);
        if (prevSelectedPeriod === "day") {
          periodTitleOfFilterBy = dayFormatAbbreviation(
            moment(startDate).format("ddd - DD.MM.YYYY")
          );
        } else if (prevSelectedPeriod === "week") {
          periodTitleOfFilterBy = "Uke nr" + " " + moment(startDate).isoWeek();
        } else if (prevSelectedPeriod === "month") {
          periodTitleOfFilterBy = moment(startDate).format("MMMM");
        } else {
          if (startDate === endDate) {
            $("#custom-period").prop("disabled", true);
          } else {
            $("#custom-period option[value='time']").addClass("disabledOption");
            $("#custom-period option[value='time']").prop("disabled", true);
          }

          periodTitleOfFilterBy =
            moment(startDate).format("DD-MM-YYYY") +
            " : " +
            moment(endDate).format("DD-MM-YYYY");
        }
      }
      setTimeout(() => $("#period-title").text(periodTitleOfFilterBy), 50);
    } else {
      $("#period-day").prop("checked", true);
    }

    $(document).on("click", ".sort", function (e) {
      e.preventDefault();
      isSorting = true;
      orderBy = $(this).attr("data-order-by");
      orderByDirection = $(this).attr("data-order-by-direction");
      productGroupUniqueId = $(this)
        .closest("tr")
        .attr("data-product-group-id");
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod
      );
    });

    $(document).on("change", "#custom-period", function (e) {
      e.preventDefault();
      customPeriod = $(this).val();
      if (customPeriod == "day") {
        $(".custom-day-container").removeClass("d-none");
      } else {
        if (!$(".custom-day-container").hasClass("d-none")) {
          $(".custom-day-container").addClass("d-none");
        }
      }
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        selectedDay
      );
    });

    $(document).on("change", "#custom-day", function (e) {
      e.preventDefault();
      selectedDay = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        selectedDay
      );
    });

    $(document).on("change", "#top-product-group-id", function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));

      $("#product-group-id")
        .selectpicker("val", ["all"])
        .selectpicker("refresh");

      topProductGroupUniqueId = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod
      );
    });

    $(document).on("change", "#supplier-id", function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      supplierId = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod
      );
    });

    $(document).on("change", "#product-group-id", function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));

      $("#top-product-group-id")
        .selectpicker("val", ["all"])
        .selectpicker("refresh");

      productGroupUniqueId = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod
      );
    });

    $(document).on("change", "#user-id", function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      userId = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod
      );
    });

    $(document).on("change", "#product-id", function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      productId = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod
      );
    });

    $(document).on("change", "#platform", function (e) {
      e.preventDefault();
      platform = $(this).val();

      if (platform === "self-service") {
        userId = 0;
        $("#user-id").val(userId);
        $("#user-id").prop("disabled", true);
      } else {
        $("#user-id").prop("disabled", false);
      }
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod
      );
    });

    $(document).on("click", ".period-button", function (e) {
      $(".period-button").removeClass("active");
      $(this).addClass("active");
      period = $(this).attr("data-value");
      prevSelectedPeriod = period !== "custom" ? period : prevSelectedPeriod;

      $("#compare").prop("disabled", false);
      if (period === "day") {
        startDate = moment().format("YYYY-MM-DD") + " 00:00";
        endDate = moment().format("YYYY-MM-DD") + " 23:59";
        const currentDayFormatted = dayFormatAbbreviation(
          moment().format("ddd - DD.MM.YYYY")
        );
        customPeriod = "time";
        $("#period-title").text(currentDayFormatted);
        if (compareBy && compareBy !== "0") {
          compareBy = "day-compare";
          $("#compare").val("day-compare").trigger("change.select2");
        }
      } else if (period === "week") {
        startDate = moment().startOf("week").format("YYYY-MM-DD") + " 00:00";
        endDate = moment().endOf("week").format("YYYY-MM-DD") + " 23:59";
        const currentWeekNumber = moment().isoWeek();
        customPeriod = "day";
        $(`#custom-period option[value="day"]`).prop("selected", true);
        $("#period-title").text("Uke nr" + " " + currentWeekNumber);
        if (compareBy && compareBy !== "0") {
          compareBy = "week-compare";
          $("#compare").val("week-compare").trigger("change.select2");
        }
      } else if (period === "month") {
        startDate = moment().startOf("month").format("YYYY-MM-DD") + " 00:00";
        endDate = moment().endOf("month").format("YYYY-MM-DD") + " 23:59";
        durationOfstartAndEndDate = 30;
        displayGraphDynamically(durationOfstartAndEndDate);
        if (isDesktop) {
          customPeriod = "day";
          $(`#custom-period option[value="time"]`).prop("selected", false);
          $(`#custom-period option[value="day"]`).prop("selected", true);
        } else {
          customPeriod = "week";
          $(`#custom-period option[value="day"]`).prop("selected", false);
          $(`#custom-period option[value="week"]`).prop("selected", true);
          $(`#custom-period option[value="day"]`).prop("disabled", true);
        }
        const currentMonth = moment().format("MMMM");
        $("#period-title").text(currentMonth);
        if (compareBy && compareBy !== "0") {
          compareBy = "month-compare";
          $("#compare").val("month-compare").trigger("change.select2");
        }
      } else if (period === "year") {
        startDate = moment().startOf("year").format("YYYY-MM-DD") + " 00:00";
        endDate = moment().endOf("year").format("YYYY-MM-DD") + " 23:59";
        displayGraphDynamically(365);
        customPeriod = "month";
        $(`#custom-period option[value="time"]`).prop("selected", false);
        $(`#custom-period option[value="month"]`).prop("selected", true);
        $("#period-title").text(moment().format("YYYY"));

        $("#compare").prop("disabled", true);
      } else {
        $("#period-title").text("Custom");
        compareBy = null;
        $("#compare").val("0").trigger("change.select2");
        if (startDate.split(" ")[0] == endDate.split(" ")[0]) {
          customPeriod = "time";
          $("#custom-period option[value='time']").prop("selected", true);
          $("#custom-period").prop("disabled", true);
          $("#custom-period").val("time").trigger("change");
        } else {
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period").prop("disabled", false);
        }
      }
      $("#start-date").val(startDate);
      $("#end-date").val(endDate);
      toggleCustomDatePicker();
      if (customPeriod == "day") {
        $(".custom-day-container").removeClass("d-none");
      } else {
        if (!$(".custom-day-container").hasClass("d-none")) {
          $(".custom-day-container").addClass("d-none");
        }
      }

      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        selectedDay
      );
    });

    function getDateAndTimeChange(callback) {
      $("#start-date").datetimepicker({
        dateFormat: "yy-mm-dd",
        timeFormat: "HH:mm",
        showButtonPanel: true,
        regional: ["no", "NO"],
        onClose: function () {
          if (startDate !== $(this).val()) {
            let choosenDate = $("#start-date").val();

            if (dateAndPeriodValidation(choosenDate, endDate)) {
              startDate = choosenDate;
              isDateChanged = true;

              if (startDate.split(" ")[0] == endDate.split(" ")[0]) {
                $("#custom-period option[value='time']").prop("selected", true);
                $("#custom-period").prop("disabled", true);
                customPeriod = "time";
              } else {
                durationOfstartAndEndDate = moment(endDate).diff(
                  moment(startDate),
                  "days"
                );
                displayGraphDynamically(durationOfstartAndEndDate);
                $("#custom-period").prop("disabled", false);
              }
              getOrderedProductQuantity(
                startDate,
                endDate,
                period,
                supplierId,
                productGroupUniqueId,
                locationId,
                userId,
                platform,
                orderBy,
                orderByDirection,
                customPeriod,
                topProductGroupUniqueId,
                compareBy,
                productId,
                vatCode,
                paymentMethod
              );
              prevSelectedPeriod = "custom";
              $("#period-title").text(
                moment(startDate).format("DD-MM-YYYY") +
                  " : " +
                  moment(endDate).format("DD-MM-YYYY")
              );
            }
          }
        },
      });

      // Initialize the Datepicker for end-date
      $("#end-date").datetimepicker({
        dateFormat: "yy-mm-dd",
        timeFormat: "HH:mm",
        showButtonPanel: true,
        onClose: function () {
          if (endDate !== $(this).val()) {
            let currentendDate = $("#end-date").val();
            if (dateAndPeriodValidation(startDate, currentendDate)) {
              isDateChanged = true;
              endDate = currentendDate;

              if (startDate.split(" ")[0] == endDate.split(" ")[0]) {
                $("#custom-period option[value='time']").prop("selected", true);
                $("#custom-period").prop("disabled", true);
                customPeriod = "time";
              } else {
                durationOfstartAndEndDate = moment(endDate).diff(
                  moment(startDate.split(" ")[0]),
                  "days"
                );
                displayGraphDynamically(durationOfstartAndEndDate);

                $("#custom-period").prop("disabled", false);
              }
              getOrderedProductQuantity(
                startDate,
                endDate,
                period,
                supplierId,
                productGroupUniqueId,
                locationId,
                userId,
                platform,
                orderBy,
                orderByDirection,
                customPeriod,
                topProductGroupUniqueId,
                compareBy,
                productId,
                vatCode,
                paymentMethod
              );
              prevSelectedPeriod = "custom";
              $("#period-title").text(
                moment(startDate).format("DD-MM-YYYY") +
                  " : " +
                  moment(endDate).format("DD-MM-YYYY")
              );
            }
          }
        },
      });
    }

    $(document).on("click", "#previous-button", function (e) {
      e.preventDefault();
      let periodTitle = "";
      if (
        period === "day" ||
        (prevSelectedPeriod === "day" && !isDateChanged && period === "custom")
      ) {
        startDate =
          moment(startDate).subtract(1, "day").format("YYYY-MM-DD") + " 00:00";
        endDate =
          moment(endDate).subtract(1, "day").format("YYYY-MM-DD") + " 23:59";
        periodTitle = dayFormatAbbreviation(
          moment(startDate).format("ddd - DD.MM.YYYY")
        );
      }
      if (
        period === "week" ||
        (prevSelectedPeriod === "week" && !isDateChanged && period === "custom")
      ) {
        startDate = moment(startDate).subtract(1, "week").format("YYYY-MM-DD");
        endDate = moment(endDate).subtract(1, "week").format("YYYY-MM-DD");
        const currentWeekNumber = moment(startDate).isoWeek();
        periodTitle = "Uke nr" + " " + currentWeekNumber;
      }

      if (
        period === "month" ||
        (prevSelectedPeriod === "month" &&
          !isDateChanged &&
          period === "custom")
      ) {
        startDate = moment(startDate).subtract(1, "month").format("YYYY-MM-DD");
        endDate =
          period === "month"
            ? moment(endDate)
                .subtract(1, "month")
                .endOf("month")
                .format("YYYY-MM-DD") + " 23:59"
            : moment(endDate).add(1, "month").format("YYYY-MM-DD") + " 23:59";
        periodTitle = moment(startDate).format("MMMM");
      }

      if (
        period === "year" ||
        (prevSelectedPeriod === "year" && !isDateChanged && period === "custom")
      ) {
        startDate =
          moment(startDate).subtract(1, "year").format("YYYY-MM-DD") + " 00:00";
        endDate =
          moment(endDate).subtract(1, "year").format("YYYY-MM-DD") + " 23:59";
        periodTitle = moment(startDate).format("YYYY");
      }

      if (period === "custom" && prevSelectedPeriod === "custom") {
        let previousStartDate = moment(startDate);
        let previousEndDate = moment(endDate);

        endDate = moment(startDate).subtract(1, "day").format("YYYY-MM-DD");

        durationOfstartAndEndDate = previousEndDate.diff(
          previousStartDate,
          "days"
        );

        startDate = moment(endDate)
          .subtract(durationOfstartAndEndDate, "days")
          .format("YYYY-MM-DD");
        periodTitle =
          moment(startDate).format("DD-MM-YYYY") +
          " : " +
          moment(endDate).format("DD-MM-YYYY");
      }
      $("#start-date").val(startDate);
      $("#end-date").val(endDate);
      $("#period-title").text(periodTitle);
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod
      );
      if (compareBy && compareBy == "day-compare") {
        let $compare = $("#compare");
        let dayCompareOption = $compare.find("option[value='day-compare']");

        if (dayCompareOption.length) {
          dayCompareOption.text(
            `i dag / forrige ${getPeriodTranslation(compareBy, startDate)}`
          );
          $compare.val("day-compare");
          $compare.trigger("change.select2");
          $compare.select2("destroy");
          $compare.select2({ theme: "bootstrap4" });
        }
      }
    });

    $(document).on("click", "#next-button", function (e) {
      e.preventDefault();
      let periodTitle = "";
      if (
        period === "day" ||
        (prevSelectedPeriod === "day" && !isDateChanged && period === "custom")
      ) {
        startDate =
          moment(startDate).add(1, "day").format("YYYY-MM-DD") + " 00:00";
        endDate = moment(endDate).add(1, "day").format("YYYY-MM-DD") + " 23:59";
        periodTitle = dayFormatAbbreviation(
          moment(startDate).format("ddd - DD.MM.YYYY")
        );
      }
      if (
        period === "week" ||
        (prevSelectedPeriod === "week" && !isDateChanged && period === "custom")
      ) {
        startDate = moment(startDate).add(1, "week").format("YYYY-MM-DD");
        endDate =
          moment(endDate).add(1, "week").format("YYYY-MM-DD") + " 23:59";
        const currentWeekNumber = moment(startDate).isoWeek();
        periodTitle = "Uke nr" + " " + currentWeekNumber;
      }

      if (
        period === "month" ||
        (prevSelectedPeriod === "month" &&
          !isDateChanged &&
          period === "custom")
      ) {
        startDate = moment(startDate).add(1, "month").format("YYYY-MM-DD");
        endDate =
          period === "month"
            ? moment(endDate)
                .add(1, "month")
                .endOf("month")
                .format("YYYY-MM-DD") + " 23:59"
            : moment(endDate).add(1, "month").format("YYYY-MM-DD") + " 23:59";
        periodTitle = moment(startDate).format("MMMM");
      }

      if (
        period === "year" ||
        (prevSelectedPeriod === "year" && !isDateChanged && period === "custom")
      ) {
        startDate =
          moment(startDate).add(1, "year").format("YYYY-MM-DD") + " 00:00";
        endDate =
          moment(endDate).add(1, "year").format("YYYY-MM-DD") + " 23:59";
        periodTitle = moment(startDate).format("YYYY");
      }

      if (period === "custom" && prevSelectedPeriod === "custom") {
        let previousStartDate = moment(startDate);
        let previousEndDate = moment(endDate);

        startDate = moment(endDate).add(1, "day").format("YYYY-MM-DD");

        durationOfstartAndEndDate = previousEndDate.diff(
          previousStartDate,
          "days"
        );

        endDate = moment(startDate)
          .add(durationOfstartAndEndDate, "days")
          .format("YYYY-MM-DD");
        periodTitle =
          moment(startDate).format("DD-MM-YYYY") +
          " : " +
          moment(endDate).format("DD-MM-YYYY");
      }
      $("#start-date").val(startDate);
      $("#end-date").val(endDate);
      $("#period-title").text(periodTitle);
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod
      );
      if (compareBy && compareBy == "day-compare") {
        let $compare = $("#compare");
        let dayCompareOption = $compare.find("option[value='day-compare']");

        if (dayCompareOption.length) {
          dayCompareOption.text(
            `i dag / forrige ${getPeriodTranslation(compareBy, startDate)}`
          );
          $compare.val("day-compare");
          $compare.trigger("change.select2");
          $compare.select2("destroy");
          $compare.select2({ theme: "bootstrap4" });
        }
      }
    });

    $(document).on("change", "#payment-method", function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      paymentMethod = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod
      );
    });

    $(document).on("change", "#location-id", function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      locationId = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod
      );
    });

    $(document).on("change", "#vat-code", function (e) {
      e.preventDefault();
      handleSelectedOptions($(this));
      vatCode = $(this).val();
      getOrderedProductQuantity(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        orderBy,
        orderByDirection,
        customPeriod,
        topProductGroupUniqueId,
        compareBy,
        productId,
        vatCode,
        paymentMethod
      );
    });

    function eventLineChart(categoryArray, seriesData1, seriesData2) {
      const { legendText, previousLegendText } = getLegendTexts(
        compareBy,
        startDate
      );
      // Calculate totals for series
      const total1 = seriesData1.reduce((sum, val) => sum + parseFloat(val), 0);
      const total2 = seriesData2?.reduce(
        (sum, val) => sum + parseFloat(val),
        0
      );

      // Render the chart
      Highcharts.chart("event-line-graph", {
        chart: {
          type: "column",
        },
        title: {
          text: null,
        },
        exporting: { enabled: false },
        plotOptions: {
          series: {
            lineWidth: 4,
          },
        },

        xAxis: {
          categories: categoryArray,
          labels: {
            formatter: function () {
              if (customPeriod === "day") {
                return Highcharts.dateFormat(
                  "%e/%b",
                  new Date(this.value).getTime()
                );
              } else if (customPeriod === "week") {
                return "Uke " + this.value;
              } else if (customPeriod === "month") {
                return Highcharts.dateFormat(
                  "%B %Y",
                  new Date(this.value).getTime()
                );
              } else {
                return this.value;
              }
            },
          },
        },
        credits: { enabled: false },
        yAxis: {
          title: {
            text: "Antall varer",
          },
        },
        series:
          !compareBy || compareBy == "0"
            ? [
                {
                  name: "Antall varer",
                  data: seriesData1.map((value, index) => [
                    categoryArray[index],
                    parseFloat(value),
                  ]),
                },
              ]
            : [
                {
                  name: `Antall varer ( ${total1} ) ${legendText}`,
                  data: seriesData1.map((value, index) => [
                    categoryArray[index],
                    parseFloat(value),
                  ]),
                },
                {
                  name: `Antall varer forrige ${getPeriodTranslation(
                    compareBy ?? "",
                    startDate
                  )} ( ${total2} ) ${previousLegendText}`,
                  data: seriesData2.map((value, index) => [
                    categoryArray[index],
                    parseFloat(value),
                  ]),
                },
              ],
        tooltip: {
          formatter: function () {
            var tooltipText;
            if (startDate.split(" ")[0] === endDate.split(" ")[0]) {
              tooltipText =
                "<b>" +
                Highcharts.dateFormat("%H:%M, %b %e", this.x) +
                "</b><br/>" +
                "Antall varer : " +
                formatNumber(this.y);
            } else if (customPeriod === "week") {
              tooltipText =
                "<b>" +
                "Uke" +
                " " +
                this.x +
                "</b><br/>" +
                "Antall varer : " +
                formatNumber(this.y);
            } else if (customPeriod === "month") {
              tooltipText =
                "<b>" +
                Highcharts.dateFormat("%B - %Y", this.x) +
                "</b><br/>" +
                "Antall varer : " +
                formatNumber(this.y);
            } else {
              tooltipText =
                "<b>" +
                Highcharts.dateFormat("%A, %b %e, %Y", this.x) +
                "</b><br/>" +
                "Antall varer : " +
                formatNumber(this.y);
            }
            return tooltipText;
          },
        },
      });
    }

    function dateAndPeriodValidation(startedDate, endedDate) {
      let start = moment(startedDate);
      let end = moment(endedDate);
      durationOfstartAndEndDateByMonths = moment(endedDate.split(" ")[0]).diff(
        startedDate.split(" ")[0],
        "months"
      );

      if (start.isAfter(end)) {
        $("#start-date").val(startDate);
        $("#end-date").val(endDate);
        return alert("end date cannot be later than start date");
      } else if (durationOfstartAndEndDateByMonths > 36) {
        $("#start-date").val(startDate);
        $("#end-date").val(endDate);
        return alert("Maksimal varighet er 3 år");
      } else {
        return true;
      }
    }
    $(document).on("change", "#compare", function (e) {
      e.preventDefault();
      compareBy = $(this).val();

      if (compareBy === "day-compare") {
        period = "day";
      } else if (compareBy === "week-compare") {
        period = "week";
      } else if (compareBy === "month-compare") {
        period = "month";
      } else {
        compareBy = null;
      }
      $(`.period-button[data-value='${period}']`).trigger("click");
    });

    function getOrderedProductQuantity(
      startDate,
      endDate,
      period = null,
      supplierId = null,
      productGroupUniqueId = null,
      locationId = null,
      userId = null,
      platform = "all",
      orderBy,
      orderByDirection,
      customPeriod,
      topProductGroupUniqueId = 0,
      compareBy = null,
      productId = 0,
      vatCode = 0,
      paymentMethod = 0,
      selectedDay = null
    ) {
      $.ajax({
        type: "POST",
        url: "/ajax/statistic_product_group/search",
        data: {
          startDate,
          endDate,
          period,
          supplierId,
          productGroupUniqueId,
          locationId,
          userId,
          platform,
          orderBy,
          orderByDirection,
          customPeriod,
          topProductGroupUniqueId,
          compareBy,
          productId,
          vatCode,
          paymentMethod,
          selectedDay,
        },
      })
        .done(function (data) {
          if (data) {
            if (data.totalQuantity) {
              $("#key-figure-text").text(parseFloat(data.totalQuantity));
            } else {
              $("#key-figure-text").text("0");
            }

            if (data.html && !isSorting) {
              $("#product-list-table").empty;
              $("#product-list-table").html(data.html);
            }
            if (data.html && isSorting) {
              $(`#product_table_${productGroupUniqueId}`).empty;
              $(`#product_table_${productGroupUniqueId}`).html(data.html);
            }
            if (
              data.xAxisArray.length > 0 &&
              data.seriesData1 &&
              data.seriesData2
            ) {
              eventLineChart(
                data.xAxisArray,
                data.seriesData1,
                data.seriesData2
              );
            }
          }
          let aTags = $(".statistic-tab-group a");
          aTags.each(function () {
            let oldHref = $(this).attr("href").split("?")[0];
            let newHref =
              oldHref +
              `?filter_by=${period}&custom_period=${customPeriod}&prev_selected_period=${prevSelectedPeriod}&start_date=${startDate}&end_date=${endDate}`;
            $(this).prop("href", newHref);
          });
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    getOrderedProductQuantity(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      orderBy,
      orderByDirection,
      customPeriod,
      topProductGroupUniqueId,
      compareBy,
      productId,
      vatCode,
      paymentMethod
    );
    toggleCustomDatePicker();
    getDateAndTimeChange();
  }
});
